module.exports = __webpack_public_path__ + "static/media/2_graph1.92cc2e26.svg";